let lastTouchEndTime = 0

const stopDoubleTapAddEventListener = () => {
  document.addEventListener(
    "touchend",
    (e: TouchEvent) => {
      const now = new Date().getTime()
      if (now - lastTouchEndTime <= 300) {
        // 偵測時間差是否小於 300ms
        e.preventDefault()
      }
      lastTouchEndTime = now
    },
    false
  )
}

export default stopDoubleTapAddEventListener
